import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCrypto: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCrypto"><Path d="M12 16.0413L8.5 14.0207V9.97934L12 7.95867L15.5 9.97934V14.0207L12 16.0413Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 6.22663L7 9.11331V14.8867L12 17.7734L17 14.8867V9.11331L12 6.22663Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCrypto;
